'use strict';
import * as T from 'prop-types';
import React, {PureComponent} from 'react';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import {Subject} from 'rxjs/Subject';
import {getAsString, getLink} from '../../../core-utilities/domain/ReduxUtils';
import {DomainImage} from '../DomainImage';
import {AvatarView} from './AvatarView';


export class AvatarComponent extends PureComponent {
  static propTypes = {
    model: T.object,
    modelAsString: T.func,
    placeholderText: T.string,
    placeholderTitle: T.string,
    targetWidth: T.number,
    targetHeight: T.number,
    displayWidth: T.number,
    displayHeight: T.number,
    cropTarget: T.bool,
    className: T.string,
    iconClass: T.string,

    init: T.bool,
  };

  static defaultProps = {
    placeholderText: '-',
    placeholderTitle: null,
    modelAsString: getAsString,
    iconClass: 'Avatar__icon',
    init: true,
  };

  static $inject = [
    'FileDomain',
  ];

  constructor(props) {
    super(props);
    this.state = {
      file: null,
      title: null,
    };
  }

  static getAvatarId(props) {
    return props.model ? getLink(props.model, 'avatar').id : null;
  }

  static getAvatar(id) {
    return id ? AvatarComponent.dependencies.FileDomain.$get(id) : Promise.resolve(null);
  }

  render() {
    const title = this.props.modelAsString(this.props.model);

    return (
      <AvatarView
        className={this.props.className}
        iconClass={this.props.iconClass}
        file={this.state.file}
        title={title || this.props.placeholderTitle}

        avatarText={this.props.model ? this.props.model.getAvatarInitials() : this.props.placeholderText}
        avatarColor={this.props.model ? this.props.model.getAvatarColor() : ''}
        avatarFontColor={this.props.model ? this.props.model.getAvatarFontColor() : ''}
      >
        {this.state.file ? (
          <DomainImage
            className={AvatarView.iconClass}
            title={title}
            file={this.state.file}
            targetWidth={this.props.targetWidth}
            targetHeight={this.props.targetHeight}
            displayWidth={this.props.displayWidth}
            displayHeight={this.props.displayHeight}
            cropTarget={this.props.cropTarget}
            placeholder={this.props.placeholderUrl}
          />
        ) : null}
      </AvatarView>
    );
  }

  withNextAvatarId(props) {
    const avatarId = AvatarComponent.getAvatarId(props);
    if (this.avatarId !== avatarId && this.avatarId$) {
      this.avatarId = avatarId;
      this.avatarId$.next(avatarId);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.withNextAvatarId(nextProps);
  }

  componentDidMount() {
    this.avatarId$ = new Subject(1);

    if (this.props.init) {
      this.initData();
    }
  }

  initData() {
    this.fileSubscription = this.avatarId$
      .distinctUntilChanged()
      .switchMap(AvatarComponent.getAvatar)
      .subscribe(file => this.setState({file}));

    this.withNextAvatarId(this.props);
  }

  componentWillUnmount() {
    this.avatarId$ = null;
    // cleanup calendar data observable
    this.fileSubscription && this.fileSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/js/files/components/Avatar/AvatarComponent.js